import { render, staticRenderFns } from "./ModalEditarUsuario.vue?vue&type=template&id=23c4c2ad"
import script from "./ModalEditarUsuario.vue?vue&type=script&lang=ts"
export * from "./ModalEditarUsuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports